import { APICONFIG } from '@config/api.config';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { IQueryResponse } from '@services/api';
import { useGetRxDb } from '@hooks/getRxdbData';
import { ProfileData } from '../profile';

type QuarterSummaryData = {
	total_meeting: number;
	site_visits: number;
	total_user_enrollment: number;
	zero_banking_users: number;
	de_growing_users: number;
	factory_visits: number;
	competition_site_visited: number;
	lead_received_in_quarter: number;
	verified_visits?: number;
	average_meet_attendance?: number;
	adopted_contractor_sites_count?: number;
};

export const useQuarterSummaryQuery = (cmdiCode?: string): IQueryResponse<QuarterSummaryData> => {
	const { result: profile } = useGetRxDb<ProfileData>('profile');

	const fetchQuarterSummaryData = async (): Promise<QuarterSummaryData> => {
		const userRole = profile[0]?.usertype_c;

		let apiEndpoint = userRole === 'RBDM' ? APICONFIG.QUARTER_SUMMARY_API_RBDM : APICONFIG.QUARTER_SUMMARY_API;

		if (userRole === 'RBDM' && cmdiCode) {
			apiEndpoint += `?mdi_code=${cmdiCode}`;
		}

		return await APIService.getData<QuarterSummaryData>(apiEndpoint);
	};

	const { data, error, isLoading, isPending, isFetching } = useQuery({
		queryKey: ['quarterSummary', profile[0]?.usertype_c, cmdiCode],
		queryFn: fetchQuarterSummaryData,
		enabled: profile.length > 0,
		refetchOnWindowFocus: false,
		retry: false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
	};
};
